import React from "react";

import Table from "../../../common/Table";
import Option from "../../../common/RowOption";

import lbl from "../../../../data/Labels.json";

const BudgetAccountsListTable = ({ data, match, query }) => {
  const { aid } = match.params;

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "budget_code",
      label: "کود بودجه",
    },
    {
      path: "name",
      label: "نام",
    },
    { path: "expense_account", label: "نوع مصرف" },
    { path: "budget", label: "بودجه" },
    { path: "paid", label: "پرداخت شده" },
    { path: "balance", label: "باقیمانده" },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment && (
          <a href={attachment} download target="_blank">
            {lbl.Download}
          </a>
        ),
    },
    {
      path: "option",
      content: (e) =>
        e.id && (
          <Option
            Edit={{ form: "expense-budget-form", aid, edit: e }}
            Delete={{ route: "expenses/budget", id: e.id }}
          />
        ),
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default BudgetAccountsListTable;
